"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _queue = function _queue() {
  for (var _len = arguments.length, fns = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    fns[_key - 1] = arguments[_key];
  }

  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (fns.length === 0) {
    return args;
  }
  var currentFn = fns[0],
      rest = fns.slice(1);

  return Promise.resolve().then(function () {
    return currentFn(args);
  }).then(function (newArg) {
    return _queue.apply(undefined, [[].concat(_toConsumableArray(args), [newArg])].concat(_toConsumableArray(rest)));
  });
};

/**
 * Executes a list of promises and waits before previous promise was resolved.
 * In difference to sequence, queue responds an array containing all resolved values.
 *
 * @param {array} fns, functions to be executed
 * @example
 *
 * const analyticsEvents = ['UserCreated', 'InvitationEmailSent']
 *   .map((event) => () => { 'send a single event to google analytics' });
 *
 * Promise.resolve()
 *   .then(queue(...analyticsEvents))
 *   .then(([responseOfUserCreated, responseOfInvitationEmailSent]) =>
 *     console.log('All events have been stored.'));
 */
var queue = exports.queue = function queue() {
  for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function () {
    return _queue.apply(undefined, [void 0].concat(fns));
  };
};